
import { CookieGet } from "@/utils/cookie.utils";
/**
 * Get laravel csrf token
 */
export const csrfToken = () => CookieGet('XSRF-TOKEN');
/**
 * Get language
 */
export const getLang = () => document.documentElement.lang.substring(0, 2);

/**
 * Generate unique ID for accessibility purposes
 * @param {string} prefix - Prefix for the ID
 * @returns {string} - Unique ID
 */
export const generateId = (prefix = 'id') => {
    const timestamp = Date.now().toString(36);
    const randomStr = Math.random().toString(36).substr(2, 5);
    return `${prefix}-${timestamp}-${randomStr}`;
};
